import R from 'ramda'
import numeral from 'numeral'
import { fromNullable, Just, Nothing } from 'data.maybe'

// import { hours, count, rating, mw, dollars } from './constants'

export const svgWidth = (containerWidth, { left, right }) => containerWidth - left - right
export const svgHeight = (containHeight, { top, bottom }) => containHeight - top - bottom

export const findMax = (maxValue, valueKeys, data) => {
  const maxValInData = R.compose(
    R.reduce(R.max, 0),
    R.map(([_, v]) => v),
    R.filter(([k, _]) => R.contains(k, valueKeys)),
    R.toPairs
  )

  const maxInAll = R.compose(R.reduce(R.max, 0), R.map(maxValInData))

  return fromNullable(maxValue)
    .orElse(() => Just(maxInAll(data)))
    .getOrElse(0)
}

// const allCols = [...hours,...count,...rating,...mw,...dollars]

const mergeUnitStats = R.mergeWith((a, b) =>
  fromNullable(a)
    .map(aa => aa + fromNullable(b).getOrElse(0))
    .getOrElse(fromNullable(b).getOrElse(0))
)

const _summarizeStats = R.compose(
  R.reduce(mergeUnitStats, {}),
  // eslint-disable-next-line no-unused-vars
  R.map(({ unitId, date, ...rest }) => ({ ...rest }))
)

const _summarize = (rollup, count, val) =>
  fromNullable(rollup)
    .chain(_ => fromNullable(count))
    .chain(c => (c === 0 ? Nothing() : Just(c)))
    .map(_ => (rollup === 'SUM' ? val : val / count))
    .getOrElse(val)

export const summarizeData = rollupMap =>
  R.compose(
    R.map(([unitId, vals]) => {
      const process = R.compose(
        R.fromPairs,
        R.map(([kpi, val]) => [kpi, _summarize(rollupMap[kpi], vals.length, val)]),
        R.toPairs,
        _summarizeStats
      )
      return { unitId, ...process(vals) }
    }),
    R.toPairs,
    R.groupBy(({ unitId }) => unitId)
  )

export const format = (val, formatter) =>
  fromNullable(val)
    .map(formatter)
    .getOrElse('')

export const pctFormatter = v => numeral(v * 0.01).format('0.000%')
export const dollarFormatter = v => numeral(v).format('$0,0.00')
export const numFormatter = v => numeral(v).format('0,0.00')

export const foreCastMetrics = [
  { display: 'EAF', id: 'eaf' },
  // { display: 'EUOR', id: 'euor' },
  { display: 'NCF', id: 'ncf' },
  { display: 'Summer EAF', id: 'seaf' },
  { display: 'SR', id: 'sr' },
  { display: 'EFOR', id: 'efor' },
  { display: 'FOR', id: 'for' },
  { display: 'EUOF', id: 'euof' },
  { display: 'UOF', id: 'uof' },
]
